import { useAccessTokenRoles } from '@b-stock/fe-core/bstock-next/components'
import { PortalName } from '@b-stock/fe-core/bstock-react'

export function usePortalName(variant: 'default' | 'storefront') {
  const accountRoles = useAccessTokenRoles()

  // Storefront variant: BUYER or SELLER based on roles. Default variant: HOME.
  const portalName =
    variant === 'storefront'
      ? accountRoles?.buyer || accountRoles?.service
        ? PortalName.BUYER
        : PortalName.SELLER
      : PortalName.HOME

  return portalName
}
